import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Revenue = lazy(() =>
  import("@scenes/Revenue").then((module) => ({
    default: module.Revenue,
  }))
);

export const revenueReportNRO: NavigationRoutingObject = {
  Component: Revenue,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("revenue-report-sidebar-pill-menu-option", "Revenue Report"),
  pageNameForTracking: () => "Revenue Report",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    return isImpersonating || userHasViewAppUsagePermission || userHasViewReportingPermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("revenue", "Revenue")],
      description: t("previously-revenue", 'Previously "Revenue"'),
    },
    {
      keywords: [
        t("revenue-alt-keyword-1", "lifetime revenue"),
        t("revenue-alt-keyword-2", "lifetime value per user"),
        t("revenue-alt-keyword-3", "daily revenue"),
        t("revenue-alt-keyword-4", "daily purchases"),
        t("revenue-alt-keyword-5", "daily revenue per user"),
        t("revenue-alt-keyword-6", "last touch revenue"),
        t("revenue-alt-keyword-7", "total purchase conversions"),
        t("revenue-alt-keyword-8", "average days to convert"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/revenue/:appGroupId",
};
